import { jwtDecode } from 'jwt-decode';

type DecodedToken = {
    permissions?: string[];
    scope?: string;
    [key: string]: any;
};

export async function getMaestroAuth(getAccessTokenSilently: any) {
    const audience = process.env.REACT_APP_AUTH0AUDIENCE_MAESTRO as string;

    try {
        const token = await getAccessTokenSilently({
            authorizationParams: { audience },
        });

        const decoded = jwtDecode<DecodedToken>(token);

        const permissions = decoded.permissions ?? [];

        console.log('Auth0 permissions:', permissions);

        return {
            permissions,
        };

    } catch (err: any) {
        console.error('API Error:', err);
        return null;
    }
}